import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useMediaQuery,
} from '@podiumhq/design-system';

import { PAYMENT_VIEW_ROUTE } from 'components/Checkout/constants';
import BundleCardHeading from 'components/PricingPackaging/components/BundleCardHeading';
import { PLAN_PACKAGES } from 'components/PricingPackaging/constants';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

const BuyNowCard = ({
  bundle,
  cardId,
  description,
  discountPercentage,
  price,
  showPopularText,
  term,
  title,
}) => {
  const { changeCheckoutPage, setSelectedPlan } =
    useSelectPlanCheckoutContext();
  const [isSmallerThan1180px] = useMediaQuery(`(max-width: 1180px)`);

  const handleBuyNow = () => {
    setSelectedPlan(PLAN_PACKAGES[bundle]);
    changeCheckoutPage(PAYMENT_VIEW_ROUTE);
  };

  return (
    <Box {...pricingCardStyles(isSmallerThan1180px)} id={`${cardId}-card`}>
      <BundleCardHeading
        headerStyles={headingStyles}
        headerText={title}
        popularText={
          !showPopularText
            ? null
            : isSmallerThan1180px
            ? 'Most Popular'
            : 'Popular'
        }
        popularTextProps={popularTextStyles}
      />

      <Text
        {...lightGreyTextStyles}
        fontSize={isSmallerThan1180px ? '14px' : 'sm'}
        margin="8px 11px 0 16px"
      >
        {description}
      </Text>

      <Flex
        align={isSmallerThan1180px ? 'center' : 'flex-start'}
        direction={isSmallerThan1180px ? 'row' : 'column'}
        justify={isSmallerThan1180px ? 'space-between' : 'flex-start'}
      >
        <Flex direction={isSmallerThan1180px ? 'row' : 'column'}>
          <Text
            {...lightGreyTextStyles}
            fontSize="md"
            margin="16px 0 0 16px"
            textDecorationLine="line-through"
          >
            ${price}
          </Text>

          <Flex align="center" mb="16px" mt="8px">
            <Heading
              color="blue.base"
              fontSize="2xl"
              fontWeight="semibold"
              ml="16px"
            >
              ${Math.floor((price * (100 - discountPercentage)) / 100)}
            </Heading>

            <Box {...lightGreyTextStyles} ml="4px" sx={{ fontSize: '8px' }}>
              <div>USD</div>
              <div>{`/${term}`}</div>
            </Box>
          </Flex>
        </Flex>

        <Button
          float={isSmallerThan1180px ? 'right' : ''}
          id={`${cardId}-btn`}
          margin="8px 16px 19px auto"
          onClick={handleBuyNow}
          size="sm"
          variant="outline"
          width={isSmallerThan1180px ? '81px' : 'calc(100% - 32px)'}
        >
          Buy now
        </Button>
      </Flex>
    </Box>
  );
};

const headingStyles = {
  mt: '24px',
  ml: '16px',
  fontSize: '17px',
  fontWeight: 'semibold',
  lineHeight: '150%',
};

const lightGreyTextStyles = {
  // color: '#808080',
  color: 'grey.lighter',
  // fontSize: 'sm',
  fontWeight: 'normal',
  lineHeight: '150%',
  // margin: '8px 11px 0 16px',
  // sx: { color: '#808080', fontSize: '12px' },
};

const pricingCardStyles = (isSmallerThan1180px) => ({
  left: '0px',
  top: '0px',
  boxShadow:
    '0px 0px 0px 0.5px rgba(18, 21, 26, 0.08), 0px 2px 2px rgba(18, 21, 26, 0.04), 0px 2px 4px -2px rgba(18, 21, 26, 0.08)',
  borderRadius: '16px',
  marginBottom: isSmallerThan1180px ? '16px' : '0',
  width: '100%',
});

const popularTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px 8px',
  gap: '10px',
  background: '#E6ECFB',
  borderRadius: '120px',
  marginTop: '26px',
  marginRight: '14px',
  fontSize: '12px',
};

export default BuyNowCard;
